import { useEffect, useState } from "react";
import { useToaster } from "../hooks/useToaster";
import { initializeAxiosInterceptors } from "../../services/interceptor-service";
import { Sidebar } from "../ui/sidebar";
import { Header } from "../../components/ui/header";
import { useLocation, Outlet } from "react-router-dom";
import { useAppDispatch } from "../../reducers/store";

export const RootProvider = () => {
  const [toasterState, openToaster, closeToaster] = useToaster();
  const [dontShowSideBar, setDontShowSideBar] = useState(true);
  const [dontShowHeader, setDontShowHeader] = useState(true);

  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    initializeAxiosInterceptors({ openToaster });
  }, []);

  useEffect(() => {
    if (location.pathname.includes("login")) {
      setDontShowSideBar(true);
    } else {
      setDontShowSideBar(false);
    }
  }, [location]);

  useEffect(() => {
    if (location.pathname.includes("login")) {
      setDontShowHeader(true);
    } else {
      setDontShowHeader(false);
    }
  }, [location]);

  function getPageTitle() {
    switch (location.pathname) {
      case "/home":
        return "Account Overview";
      case "/team":
        return "Your Teams";
      case "/analytics":
        return "Analytics";
      case "/settings":
        return "Account Settings";
      case "/approvals":
        return "Approvals";
    }
  }

  return (
    <div className="flex h-screen w-screen flex-row flex-wrap content-start">
      {!dontShowSideBar && <Sidebar />}
      {!dontShowHeader && <Header pageTitle={getPageTitle()} />}
      <div className="relative ml-[5vw] h-[calc(100vh-85px)] w-[calc(100vw-5vw)] overflow-hidden bg-[#f6f6f6] p-[1vw] py-[16px] max-[600px]:h-[calc(100vh-170px)] min-h-[900px]">
        <Outlet />
      </div>
    </div>
  );
};
